module.exports = __webpack_public_path__ + "static/August-2019-2-english-9eaf125fdebc6859152fcd5ee2e2c33a.pdf";